import { SerdeTransformTypeEnum } from '@zaoblako/shared/modules/serde/enums/serde-transform-type.enum';
import { SerdeEnvironmentEnum } from '@zaoblako/shared/modules/serde/enums/serde-environment.enum';
import type { SerdeContextFactoryInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-factory.interface';

/** Global service which provide base validation context initialize */
export class SerdeContextProviderClass {
  private static instance: SerdeContextProviderClass = null;

  public static getInstance(): SerdeContextProviderClass {
    if (!SerdeContextProviderClass.instance) {
      SerdeContextProviderClass.instance = new SerdeContextProviderClass();
    }
    return SerdeContextProviderClass.instance;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public getBaseContext: SerdeContextFactoryInterface = (
    transform?: SerdeTransformTypeEnum,
  ) => ({
    environment: SerdeEnvironmentEnum.BACKEND,
    transform: transform || SerdeTransformTypeEnum.DESERIALIZE,
    data: {},
  });
}
